module.exports = __webpack_public_path__ + "92293cf7d1f1c56ead57171e02ed0d22.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/medias/images/paper.png
// module id = 879
// module chunks = 3